const SCREEN_HEIGHT_PART = 0.35

export default {
  name: 'HomePage',
  data: function () {
    return {
      navElem: null,
      sectionsCollection: null,
      activeNav: null,
      activeSectionId: null,
      isOnScrollAdded: false,
      isOnScrollMobileAdded: false
    }
  },
  methods: {
    setActiveTab: function () {
      this.$router.push({name: 'contact', params: {activeOptionWorkAt: 1}})
    },
    handleClickNav: function (e) {
      if (this.sectionsCollection) {
        e.preventDefault()
        window.scrollTo(0, this.sectionsCollection[e.target.hash].start)
      }
    },
    handleOnResize: function () {
      if (!this.isOnScrollAdded && !this.isOnScrollMobileAdded) {
        this.navElem = document.querySelector('#home-page-navigation')

        if (!this.sectionsCollection) {
          this.sectionsCollection = {}
          let i = this.navElem.children.length
          for (;i--;) {
            let propName = this.navElem.children[i].hash
            let sectionElem = document.querySelector(propName)
            sectionElem.classList.toggle('animate', false)

            if (sectionElem) {
              this.sectionsCollection[propName] = {
                elem: sectionElem,
                start: sectionElem.offsetTop,
                inView: sectionElem.offsetTop + window.innerHeight * SCREEN_HEIGHT_PART,
                end: sectionElem.offsetTop + sectionElem.offsetHeight - window.innerHeight * SCREEN_HEIGHT_PART
              }
            }
          }
        }
      }

      if (window.innerWidth >= 768 && !this.isOnScrollAdded) {
        this.handleOnScroll()
        window.addEventListener('scroll', this.handleOnScroll)
        window.removeEventListener('scroll', this.handleOnScrollMobile)
        this.isOnScrollAdded = true
        this.isOnScrollMobileAdded = false
      } else if (window.innerWidth < 768 && !this.isOnScrollMobileAdded) {
        window.removeEventListener('scroll', this.handleOnScroll)
        window.addEventListener('scroll', this.handleOnScrollMobile)
        this.isOnScrollAdded = false
        this.isOnScrollMobileAdded = true
        this.setNewActiveNav(null)
      }
    },
    handleOnScroll: function () {
      if (this.activeSectionId) {
        if (this.sectionsCollection[this.activeSectionId].inView <= window.scrollY + window.innerHeight && this.sectionsCollection[this.activeSectionId].end > window.scrollY) {
          this.sectionsCollection[this.activeSectionId].elem.classList.toggle('animate', true)

          if (!this.activeNav) {
            this.setNewActiveNav(document.querySelector(`a[href='${this.activeSectionId}'`))
          }
        } else {
          this.setNewActiveNav(null)
          this.activeSectionId = null

          this.findVisibleSection()
        }
      } else {
        this.findVisibleSection()
      }
    },
    handleOnScrollMobile: function () {
      this.findVisibleSection(false)

      if (this.activeSectionId && this.sectionsCollection[this.activeSectionId].inView <= window.scrollY + window.innerHeight && this.sectionsCollection[this.activeSectionId].end > window.scrollY) {
        this.sectionsCollection[this.activeSectionId].elem.classList.toggle('animate', true)
      }
    },
    setNewActiveNav: function (newNav) {
      if (this.activeNav) {
        this.activeNav.classList.toggle('nav__link--active', false)
      }
      this.activeNav = newNav
      if (this.activeNav) {
        this.activeNav.classList.toggle('nav__link--active', true)
      }
    },
    findVisibleSection: function (isDesktop = true) {
      for (let i in this.sectionsCollection) {
        if (this.sectionsCollection[i].inView <= window.scrollY + window.innerHeight && this.sectionsCollection[i].end > window.scrollY) {
          this.activeSectionId = i
        }
      }

      if (isDesktop) {
        const selector = 'a[href=\'' + this.activeSectionId + '\']'
        this.setNewActiveNav(document.querySelector(selector))
      }
    }
  },
  mounted () {
    this.$nextTick(function () {
      // TODO: Trying to find solution when use only Vue.js
      // This setTimeout used to kick handleOnResize function from Vue.js event scope, because on mobile devices it's not work correct with elements positions, method starts before all content was render
      setTimeout(this.handleOnResize, 0)
      window.addEventListener('resize', this.handleOnResize)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleOnResize)
    window.removeEventListener('scroll', this.handleOnScroll)
  }
}



// WEBPACK FOOTER //
// ./src/components/HomePage/HomePage.js